import { InjectionToken } from '@angular/core';

/**
 * One entry per feature state that survives a restart. A feature contributes its own entry
 * as a multi-provider next to its own code, so nothing central has to know its shape.
 */
export interface PersistedSlice<T> {
  /** Key in the store and in storage at once — the convention is that they are the same. */
  name: string;
  /**
   * Turns whatever storage held into valid state for this slice. Must cope with anything,
   * including `undefined` for a slice that was never written, and return the defaults then.
   */
  reshape: (stored: unknown) => T;
}

export const PERSISTED_SLICES = new InjectionToken<readonly PersistedSlice<unknown>[]>(
  'PERSISTED_SLICES',
);
